module.exports = __webpack_public_path__ + "fa2772327f55d8198301fdb8bcfc8158.woff";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-css-only/fonts/glyphicons-halflings-regular.woff
// module id = 455
// module chunks = 1